import {
	bodyCopyBold,
	bodyCopyLarge,
	bodyCopyLink,
	bodyCopyMedium,
	bodyCopySmall,
	bodyCopyXSmall,
	cappedHeaderLarge,
	cappedHeaderMedium,
	cappedHeaderSmall,
	headlineExSmall,
	headlineLarge,
	headlineMedium,
	headlineSmall,
	labelMedium,
	labelSmall,
	sectionHeaderLarge,
	sectionHeaderMedium,
	sectionHeaderSmall,
} from '@aon/aon-tws-common-ui/build/lib/globalCss';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import styled from 'styled-components';

export const CursorPointer = styled.span`
	cursor: pointer;
`;
export const HeadlineLarge = styled.p`
	${headlineLarge};
`;
HeadlineLarge.displayName = 'HeadlineLarge';
export const HeadlineMedium = styled.p`
	${headlineMedium};
`;
HeadlineMedium.displayName = 'HeadlineMedium';
export const HeadlineSmall = styled.p`
	${headlineSmall};
`;
HeadlineSmall.displayName = 'HeadlineSmall';
export const HeadlineExSmall = styled.p`
	${headlineExSmall};
`;
HeadlineExSmall.displayName = 'HeadlineExSmall';
export const BodyCopyLarge = styled.p`
	${bodyCopyLarge};
`;
BodyCopyLarge.displayName = 'BodyCopyLarge';
export const BodyCopyMedium = styled.p`
	${bodyCopyMedium};
`;
BodyCopyMedium.displayName = 'BodyCopyMedium';
export const BodyCopySmall = styled.p`
	${bodyCopySmall};
`;
BodyCopySmall.displayName = 'BodyCopySmall';
export const BodyCopyXSmall = styled.p`
	${bodyCopyXSmall};
`;
BodyCopyXSmall.displayName = 'BodyCopyXSmall';
export const BodyCopyXSmallSpan = styled.span`
	${bodyCopyXSmall};
`;
BodyCopyXSmall.displayName = 'BodyCopyXSmallSpan';
export const BodyCopyBold = styled.span`
	${bodyCopyBold};
`;
BodyCopyBold.displayName = 'BodyCopyBold';
export const BodyCopyLink = styled.a`
	${bodyCopyLink};
`;
BodyCopyLink.displayName = 'BodyCopyLink';
export const LabelMedium = styled.p`
	${labelMedium};
`;
LabelMedium.displayName = 'LabelMedium';
export const LabelSmall = styled.p`
	${labelSmall};
`;
LabelSmall.displayName = 'LabelSmall';
export const SectionHeaderLarge = styled.p`
	${sectionHeaderLarge};
`;
SectionHeaderLarge.displayName = 'SectionHeaderLarge';
export const SectionHeaderMedium = styled.p`
	${sectionHeaderMedium};
`;
SectionHeaderMedium.displayName = 'SectionHeaderMedium';
export const SectionHeaderSmall = styled.p`
	${sectionHeaderSmall};
`;
SectionHeaderSmall.displayName = 'SectionHeaderSmall';
export const CappedHeaderLarge = styled.p`
	${cappedHeaderLarge};
`;
CappedHeaderLarge.displayName = 'CappedHeaderLarge';
export const CappedHeaderMedium = styled.p`
	${cappedHeaderMedium};
`;
CappedHeaderMedium.displayName = 'CappedHeaderMedium';
export const CappedHeaderSmall = styled.p`
	${cappedHeaderSmall};
`;
CappedHeaderSmall.displayName = 'CappedHeaderSmall';

export const ContentContainer = styled.div`
	text-align: center;
	position: relative;
	margin-top: 145px;
	@media (min-width: 0) and (max-width: 768px) {
		margin-top: 95px;
	}
`;
ContentContainer.displayName = 'ContentContainer';

export const InstructionsContainer = styled.div.attrs<{}>({
	className: 'tws-instructions-container',
})``;
InstructionsContainer.displayName = 'InstructionsContainer';

export const InstructionsTitle = styled.p.attrs<{}>({
	className: 'tws-instructions-title',
})`
	${headlineSmall};
	font-weight: bold;
	margin-bottom: 30px;
`;
InstructionsTitle.displayName = 'InstructionsTitle';

export const InstructionsText = styled.p.attrs<{}>({
	className: 'tws-instructions-text',
	'data-testid': 'tws-instructions-text',
})`
	max-width: 570px;
	${bodyCopyLarge};
	display: inline-block;
	margin-bottom: 40px;
`;
InstructionsText.displayName = 'InstructionsText';

export const WarningModalHeadline = styled.p`
	${headlineExSmall}
	text-align: center;
`;
WarningModalHeadline.displayName = 'WarningModalHeadline';

export const WarningModalBody = styled.div`
	${bodyCopyMedium}
	text-align: center;
`;
WarningModalBody.displayName = 'WarningModalBody';
export const WarningIconStyle = styled.div`
	color: ${globalVars.red};
	position: absolute;
	height: 18px;
	right: 5px;
	top: 5px;
`;

export const RightButtonContainer = styled.div`
	float: right;
`;
RightButtonContainer.displayName = 'RightButtonContainer';
